'use client';

import './style.sass';

import CrewContainer from '../../layouts-components__common-cases/crew-container';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import clsx from 'clsx';
import ScrollAnimation from 'core/ScrollAnimation';
import { DobroTeamMembersType } from '@/(home)/cases/development/dobro/constant';

const team = {
    crewList: [
        {
            crewItemImg: '',
            crewItemTitle: 'Полина Герасимова ',
            crewItemSubtitle: 'Руководитель проектного офиса',
        },
        {
            crewItemImg: '',
            crewItemTitle: 'Головко Татьяна',
            crewItemSubtitle: 'Менеджер проекта',
        },
        {
            crewItemImg: '',
            crewItemTitle: 'Павел Воробьев',
            crewItemSubtitle: 'Руководитель фронтенд-направления',
        },
        {
            crewItemImg: '',
            crewItemTitle: 'Александр Забанов',
            crewItemSubtitle: 'Руководитель бэкенд-направления',
        },
        {
            crewItemImg: '',
            crewItemTitle: 'Евгений Терещенко',
            crewItemSubtitle: 'Руководитель отдела бизнес-аналитиков',
        },
        {
            crewItemImg: '',
            crewItemTitle: 'Николай Цай',
            crewItemSubtitle: 'Руководитель отдела UX/UI дизайна',
        },
        {
            crewItemImg: '',
            crewItemTitle: 'Илья Рыбаков',
            crewItemSubtitle: 'Руководитель QA-отдела',
        },
        {
            crewItemImg: '',
            crewItemTitle: '2 менеджера проекта',
            crewItemSubtitle: '',
        },
        {
            crewItemImg: '',
            crewItemTitle: '5 фронтенд-разработчиков',
            crewItemSubtitle: '',
        },
        {
            crewItemImg: '',
            crewItemTitle: '4 бэкенд-разработчика',
            crewItemSubtitle: '',
        },
        {
            crewItemImg: '',
            crewItemTitle: '5 бизнес-аналитиков',
            crewItemSubtitle: '',
        },
        {
            crewItemImg: '',
            crewItemTitle: '4 QA-инженера',
            crewItemSubtitle: '',
        },
        {
            crewItemImg: '',
            crewItemTitle: '2 DevOps-инженера',
            crewItemSubtitle: '',
        },
    ],
};

interface TeamProps {
    teamClassName?: string;
    members?: DobroTeamMembersType;
}

function Team({ teamClassName, members }: TeamProps) {
    const teamMember = members ? members : team;
    return (
        <ScrollAnimation>
            <div className={clsx('rgs-team', teamClassName)}>
                <FullWrapper className={teamClassName}>
                    <div className="rgs-team__Title">Команда</div>
                    <CrewContainer container={teamMember} />
                </FullWrapper>
            </div>
        </ScrollAnimation>
    );
}

export default Team;
